// extracted by mini-css-extract-plugin
export default {"footerContainer":"o_aDhG"};